/**
 * TODO STE-1606: replace this placeholder header with proper JSDoc and a Storybook story
 * WIP
 */
import * as React from "react";
import { PropsWithChildren } from "react";

import { css, cx } from "@emotion/css";
import Select, { SelectProps } from "@mui/material/Select";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

const BORDER_RADIUS_PX = 24;

export type BaseDropDownSelectProps = PropsWithChildren<{
  value: string | undefined;
  fullWidth?: boolean;
  onChange?: SelectProps["onChange"];
  onBlur?: SelectProps["onBlur"];
  onFocus?: SelectProps["onFocus"];
  onClick?: SelectProps["onClick"];
  disabled?: boolean;
  error?: boolean;
}>;

export type DropDownSelectClasses = StyleClasses<keyof SelectProps["classes"]>;

export type DropDownSelectProps = AtomProps<BaseDropDownSelectProps, DropDownSelectClasses>;

/**
 * DropDownSelect is a functional React component that renders a customized dropdown list
 *
 */
export const DropDownSelect: React.FC<DropDownSelectProps> = ({ className, ...props }) => {
  const styles = useStyles(makeStyles);
  return <Select {...props} className={cx(styles.select, className)} />;
};

const makeStyles = (theme: Theme) => ({
  select: css`
    background-color: ${theme.palette.grey[100]};
    border: none;
    border-radius: ${BORDER_RADIUS_PX}px;
    .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    &:hover .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    & .MuiSelect-select {
      padding: ${theme.spacing(2)} ${theme.spacing(8)};
    }
    & .Mui-error {
      border: 1px solid ${theme.palette.error.main};
      border-radius: ${BORDER_RADIUS_PX}px;
    }
  `,
});
